"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("listing-review-form", className, styles.root),
        editor: styling_1.mergeStyles("listing-review-form-editor", styles.editor),
        actions: styling_1.mergeStyles("listing-review-form-actions", styles.actions)
    };
});
exports.getClassNames = getClassNames;
